module.exports = __webpack_public_path__ + "static/media/Bandwagon Effect.c4f69939.jpg";